import { useCallback, useEffect, useState } from 'react';
import { RELEASES_SORT_BY_DEFAULT, ReleasesSortBy } from 'ui-components';
import {
  getReleasesSortFromLocalStorage,
  saveReleasesSortPreference,
} from '../../utils/releasesSortStorage';

export const useReleasesSort = () => {
  const [releasesSortBy, setReleasesSortBy] = useState<ReleasesSortBy>(
    RELEASES_SORT_BY_DEFAULT
  );

  useEffect(() => {
    const stored = getReleasesSortFromLocalStorage();
    if (stored) setReleasesSortBy(stored);
  }, []);

  const onReleasesSortChange = useCallback((sortBy: ReleasesSortBy) => {
    setReleasesSortBy(sortBy);
    saveReleasesSortPreference(sortBy);
  }, []);

  return { releasesSortBy, onReleasesSortChange };
};
